import { updateObject } from "../../Utils/Utils";

import {
    AUTH_SUCCESS,
    AUTH_LOGOUT,
    UPDATE_IMAGE
} from "../Action/AuthAction";

const initialState = {
    isLoggedIn: false,
    userInfo: {},
    refreshPath: window.location.pathname
}

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SUCCESS:
            const { userInfo } = action;
            return updateObject(state, {
                isLoggedIn: true,
                userInfo
            });

        case AUTH_LOGOUT:
            return updateObject(state, {
                isLoggedIn: false,
                userInfo: {}
            });
        case UPDATE_IMAGE:
            if (action.tempUrl && !action.tempUrl.startsWith('blob:')) {
                localStorage.setItem('image_name', action.tempUrl);
            } else if (action.tempUrl && action.tempUrl.startsWith('blob:')) {
                localStorage.removeItem('image_name');
            }
            const _userInfo = { ...state.userInfo, ['image_name']: action.tempUrl }
            return updateObject(state, {
                userInfo: _userInfo
            });
        default:
            return state;
    }
}

export default AuthReducer;